import mirrorCreator from 'mirror-creator';

export default mirrorCreator([
  'FINAL_GO_TO_STEP',
], { prefix: 'final/' });



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/finalWizardConstants.js